import HttpService from "./HttpService";

async function fetchFundingAccounts() {
  const response = await HttpService.getAxiosClient().get(
    window.API_URL + `/funds/accounts`
  );
  return response;
}

async function loadFundsToAccount(accountGuid, request) {
  const response = await HttpService.getAxiosClient().post(
    window.API_URL + `/funds/accounts/${accountGuid}/load`,
    request
  );
  return response;
}

async function removeFundsFromAccount(accountGuid, request) {
  const response = await HttpService.getAxiosClient().post(
    window.API_URL + `/funds/accounts/${accountGuid}/remove`,
    request
  );
  return response;
}

const FundsManagementService = {
  fetchFundingAccounts,
  loadFundsToAccount,
  removeFundsFromAccount,
};

export default FundsManagementService;
